import { Deserializable } from '../protocols/deserializable';
import { RetirementProductSubmissionAvailability } from './retirement-product-submission-availability';

export class MemberRetirementProductSubmissionAvailability implements Deserializable {
  public memberId!: number;
  public variableBenefitConfiguration!: RetirementProductSubmissionAvailability;
  public updateVariableBenefitConfiguration!: RetirementProductSubmissionAvailability;
  public variableBenefitPaymentChange!: RetirementProductSubmissionAvailability;
  public annuitySetup!: RetirementProductSubmissionAvailability;

  public onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    this.variableBenefitConfiguration = Deserialize?.instanceOf(
      RetirementProductSubmissionAvailability,
      this.variableBenefitConfiguration
    );
    this.updateVariableBenefitConfiguration = Deserialize?.instanceOf(
      RetirementProductSubmissionAvailability,
      this.updateVariableBenefitConfiguration
    );
    this.variableBenefitPaymentChange = Deserialize?.instanceOf(
      RetirementProductSubmissionAvailability,
      this.variableBenefitPaymentChange
    );
    this.annuitySetup = Deserialize?.instanceOf(RetirementProductSubmissionAvailability, this.annuitySetup);
  }
}
